<template>
  <div>
    <label class="typo__label"><slot></slot></label>
    <multiselect v-model="value2" 
    tag-placeholder="Add this as new tag" 
    placeholder="Search or add a tag" 
    label="Description" 
    track-by="Description" 
    :options="categories" 
    :multiple="true" 
    :taggable="true" 
    @tag="addTag"></multiselect>
  </div>  
</template>


<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {Multiselect},
  props: ['value'],
  data () {
    return {
      value2: [
        // { name: 'Javascript', code: 'js' }
        // {
        //   Cat_ID: "25",
        //   Store_ID: "1001",
        //   Description: "Cigarettes 25's"
        // }
      ],
      categories: [],
    }
  },
  watch: {
    'value2': 'emitValue'
  },
  created : function(){
    this.loadCategories();
  },
  computed: {
    categoriesObj: function(){
      let result = {}
      this.categories.forEach(row=>result[row.Cat_ID] = row);
      return result;
    },
    subtypes: function(){
      return this.value2.map(r=>r.Cat_ID);
    }
  },
  methods: {
    loadCategories: async function(){
      let r = await this.$axios.get(`/api/RMGB/categories`)
      this.categories = r.data;

      if (this.value){
        this.value.forEach(r=>this.categoriesObj[r] ? this.value2.push(this.categoriesObj[r]) : 1+1)
      }
    },
    emitValue: function(val){
      if (val === undefined){
        return;
      }
            // console.log(this.value2)
      if(this.categories.length > 0){
        this.$emit('input', this.subtypes)
        console.log('debug watch value2', this.subtypes, this.value2)
      }
    },
    addTag (newTag) {
      const tag = {
        ItemName: newTag,
        // code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      // this.categories.push(tag)
      this.value2.push(tag)
      // this.$emit('input', this.subtypes)
    }
  }
}
</script>

<style scoped>
/* Reset to fix bug */
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>